module.exports = __webpack_public_path__ + "img/assess.2e04b092.png";